var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.certificates),function(certificate){return _c('div',{key:certificate.id,class:("" + _vm.cols)},[_c('CourseBasicCertifiedItem',{attrs:{"certificate":certificate}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }